//require("@rails/ujs").start()
//require("turbolinks").start()
//require("@rails/activestorage").start()
//require("channels")
//require("jquery")

require("trix")
require("@rails/actiontext")

import '../javascripts/button';
import '../javascripts/direct_uploads';
import '../javascripts/globals.js';
import '../javascripts/header.js';
import '../javascripts/hover_menu.js';
import '../javascripts/messages.js';
import '../javascripts/spinner.js';
import '../javascripts/plyr.js';
import '../javascripts/cookieconsent.js';

import * as info_layer from '../javascripts/info_layer';